/**
 * Parent Theme → Child Tag Mapping
 * This defines which child tags belong to which parent categories
 */

const PARENT_TAG_MAP = {
  'SEASONAL & HOLIDAY': [
    'Christmas', 'Easter', 'Halloween', 'Holiday', 'Pride', 
    'Seasonal', 'St Patrick\'s Day', 'Summer', 'Valentine\'s Day'
  ],
  
  'KINK & FETISH': [
    'Beards', 'Bears', 'BDSM', 'Boys', 'Butt Plug', 'Chastity', 
    'Chub', 'Cowboys', 'Daddies', 'Furry', 'Kink', 'Leather', 
    'Men in Action', 'Outdoors', 'Piggy', 'Pups', 'School-Time'
  ],
  
  'BODY PARTS & GEAR': [
    'Arm Bands', 'Ass', 'Boots', 'Bulge', 'Feet', 'Fully Exposed', 
    'Hat', 'Mask', 'Sneakers', 'Socks'
  ],
  
  'BODY TYPES & IDENTITIES': [
    'Beards', 'Bears', 'Boys', 'Chub', 'Daddies', 
    'Gym', 'Gaymer', 'Pups', 'Trans'
  ],
  
  'ROLE PLAY & UNIFORMS': [
    'Cowboys', 'School-Time', 'Sports', 'Uniforms'
  ],
  
  'SPORTS & FITNESS': [
    'Gym', 'Sports'
  ],
  
  'LIFESTYLE': [
    'Alcohol-Related', 'Gym', 'Outdoors', 'Sports'
  ],
  
  'AQUATICS': [
    'Aquatic', 'Beach', 'Nautical', 'Pool Party'
  ],
  
  'ART STYLES': [
    'Collage', 'Cutesy', 'Look Closely', 'Movie-Inspired', 
    'Pop Art', 'Text Art'
  ],
  
  'FANTASY & PLAYFUL': [
    'Disney', 'Fantasy', 'Food', 'Furry', 'Gaymer', 
    'Magic', 'Romantic', 'Science', 'Zodiac'
  ],
  
  'HUMOR & ATTITUDE': [
    'Alcohol-Related', 'Collage', 'Food', 'Funny', 'Look Closely', 
    'Movie-Inspired', 'Night Out', 'Pop Art', 'Romantic', 'Text Art'
  ],
  
  'GET BOTTOM\'D': [
    'Get Bottom\'d'
  ],
  
  'THE HEATSTROKE LINE': [
    'PV Line'
  ],
  
  'FOR THE PUPS': [
    'Pups'
  ],
  
  'TEAM EGGPLANT': [
    'Team Eggplant'
  ],
  
  'TEAM PEACH': [
    'Team Peach'
  ]
};

/**
 * Helper function: Get parent categories for a given child tag
 * @param {string} childTag - The child tag to look up
 * @returns {array} - Array of parent category names
 */
function getParentCategories(childTag) {
  const parents = [];
  
  Object.entries(PARENT_TAG_MAP).forEach(([parent, children]) => {
    if (children.includes(childTag)) {
      parents.push(parent);
    }
  });
  
  return parents;
}

/**
 * Helper function: Get all child tags for given parent categories
 * @param {array} parentCategories - Array of parent category names
 * @returns {array} - Array of all child tags under those parents
 */
function getChildTagsForParents(parentCategories) {
  const allTags = new Set();
  
  parentCategories.forEach(parent => {
    const tags = PARENT_TAG_MAP[parent] || [];
    tags.forEach(tag => allTags.add(tag));
  });
  
  return Array.from(allTags);
}